import {joinObjects} from './helper';

const parseValue = (value) => {
  if (Array.isArray(value))
    if (value.length === 1) return value[0];
    else return value;
  else return value;
};

const parseType = (d) => d.toLowerCase();

const parseChartReportStack = (data, parsedData, yAxisId, rowData, rowIndex) => {
  let parseResult = parsedData.slice();
  let item = {};
  if (data.sets[yAxisId].xLabel.labels[rowIndex])
    item[`sets_xLabel_label`] = data.sets[yAxisId].xLabel.labels[rowIndex];
  item[`sets_${yAxisId}_data_${rowIndex}_label`] = rowData.label;
  item[`sets_${yAxisId}_data_${rowIndex}___typename`] = rowData.__typename;
  rowData.bars.forEach((bar, barIndex) => {
    item[`sets_${yAxisId}_data_${rowIndex}_bars_${barIndex}_label`] = bar.label;
    item[`sets_${yAxisId}_data_${rowIndex}_bars_${barIndex}_value`] = parseValue(bar.value);
    if (bar.appearance)
      item[`sets_${yAxisId}_data_${rowIndex}_bars_${barIndex}_appearance_color`] = bar.appearance.color;
  });
  parseResult.push(item);
  return parseResult;
};

const parseChartReportLine = (data, parsedData, yAxisId, rowItem, rowIndex) => {
  let parseResult = parsedData.slice();
  rowItem.points.forEach((point, pointIndex) => {
    if (rowIndex === 0) {
      let placeholder = {};
      if (data.sets[yAxisId].xLabel.labels[pointIndex])
        placeholder[`sets_xLabel_label`] = data.sets[yAxisId].xLabel.labels[pointIndex];
      placeholder[`sets_${yAxisId}_data_${rowIndex}_label`] = rowItem.label;
      placeholder[`sets_${yAxisId}_data_${rowIndex}___typename`] = rowItem.__typename;
      placeholder[`sets_${yAxisId}_data_${rowIndex}_appearance_type`] = rowItem.appearance.type;
      placeholder[`sets_${yAxisId}_data_${rowIndex}_appearance_color`] = rowItem.appearance.color;
      placeholder[`sets_${yAxisId}_data_${rowIndex}_appearance_dashArray`] = rowItem.appearance.dashArray;
      placeholder[`sets_${yAxisId}_data_${rowIndex}_points_value`] = parseValue(point.value);
      placeholder[`sets_${yAxisId}_data_${rowIndex}_points_showLabel`] = point.showLabel;
      if (point.labelValue) {
        placeholder[`sets_${yAxisId}_data_${rowIndex}_points_labelValue`] = parseValue(point.labelValue);
      }
      parseResult.push(placeholder);
    } else {
      if (data.sets[yAxisId].xLabel.labels[pointIndex] && parseResult[pointIndex])
        parseResult[pointIndex][`sets_xLabel_label`] = data.sets[yAxisId].xLabel.labels[pointIndex];
      parseResult[pointIndex][`sets_${yAxisId}_data_${rowIndex}_label`] = rowItem.label;
      parseResult[pointIndex][`sets_${yAxisId}_data_${rowIndex}___typename`] = rowItem.__typename;
      parseResult[pointIndex][`sets_${yAxisId}_data_${rowIndex}_appearance_type`] = rowItem.appearance.type;
      parseResult[pointIndex][`sets_${yAxisId}_data_${rowIndex}_appearance_color`] = rowItem.appearance.color;
      parseResult[pointIndex][`sets_${yAxisId}_data_${rowIndex}_appearance_dashArray`] = rowItem.appearance.dashArray;
      parseResult[pointIndex][`sets_${yAxisId}_data_${rowIndex}_points_value`] = parseValue(point.value);
      parseResult[pointIndex][`sets_${yAxisId}_data_${rowIndex}_points_showLabel`] = point.showLabel;
      if (point.labelValue) {
        parseResult[pointIndex][`sets_${yAxisId}_data_${rowIndex}_points_labelValue`] = parseValue(point.labelValue);
      }
    }
  });
  return parseResult;
};

const parseSide = (data, yAxisId) => {
  let parsedData = [];
  if (data.sets && data.sets[yAxisId] && data.sets[yAxisId].data) {
    data.sets[yAxisId].data.forEach((rowData, rowIndex) => {
      switch (rowData.__typename) {
        case 'ChartReportStack':
          parsedData = parseChartReportStack(data, parsedData, yAxisId, rowData, rowIndex);
          break;
        case 'ChartReportLine':
          parsedData = parseChartReportLine(data, parsedData, yAxisId, rowData, rowIndex);
          break;
        default:
          break;
      }
    });
  }
  return parsedData;
};

const parse = (data) => {
  console.log('full', data);
  const left = parseSide(data, 'left');
  const right = parseSide(data, 'right');
  let parsedData = [];
  // get the longer array, just in case left and right datapoints are not the same amount
  let use = left.length > right.length ? left : right;
  use.forEach((item, index) => {
    parsedData.push(joinObjects(left[index], right[index]));
  });
  return parsedData;
};

export {parseType, parse};
